import {
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  Box,
} from '@mui/material';
import type { Dictionary } from '../i18n';

interface Props {
  t: Dictionary;
  open: boolean;
  onClose: () => void;
}

function Key({ children }: { children: string }) {
  return (
    <Box
      component="kbd"
      sx={{
        px: 1,
        py: 0.25,
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'action.hover',
        fontFamily: 'ui-monospace, monospace',
        // rem, so it follows the theme's base size instead of pinning to 13px.
        fontSize: '0.8125rem',
      }}
    >
      {children}
    </Box>
  );
}

export function ShortcutsDialog({ t, open, onClose }: Props) {
  const rows: [string, string[]][] = [
    [t.shortcutUndo, ['Ctrl', 'Z']],
    [t.shortcutRedo, ['Ctrl', 'Shift', 'Z']],
    [t.shortcutDownload, ['Ctrl', 'S']],
    [t.shortcutMove, ['←', '↑', '→', '↓']],
    [t.shortcutMoveFast, ['Shift', '←/→']],
    [t.upload, ['Ctrl', 'V']],
  ];

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{t.shortcuts}</DialogTitle>
      <DialogContent>
        <Stack spacing={1.5} sx={{ pb: 1 }}>
          {rows.map(([label, keys]) => (
            <Stack key={label} direction="row" spacing={2} sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="body2">{label}</Typography>
              <Stack direction="row" spacing={0.5}>
                {keys.map((key) => (
                  <Key key={key}>{key}</Key>
                ))}
              </Stack>
            </Stack>
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
